import { render, staticRenderFns } from "./AppBreadcrumbs.vue?vue&type=template&id=2234b0e6&scoped=true"
import script from "./AppBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./AppBreadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./AppBreadcrumbs.vue?vue&type=style&index=0&id=2234b0e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2234b0e6",
  null
  
)

export default component.exports